module.exports = __webpack_public_path__ + "media/src/PriceCalculator/images/percent-discount-6c6ec5b0e9a5ba9618f5e78e6ec5b28e.svg";